import React, { useEffect, useState } from "react";
import { useIntl } from 'react-intl';

// Components
import { Grid } from "@mui/material";
import Select from 'Components/Select';
import { Form, Pill, Chip, Tooltip } from 'Components';

// Helpers
import { useSelector, useDispatch } from "react-redux";

//Actions
import { alertsWizardAlertSearchWarnings } from 'Modules/alerts/components/wizardAlert/redux/slice'

export const Warning = (props) => {

    const { value, onChange, formRef } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { warnings, loading } = useSelector(state => state.alertsConfigRedux)

    useEffect(() => {
        if (value.warnings == undefined)
            onChange({
                ...value,
                warnings: [],
                type: "warnings"
            })
    }, [value])

    useEffect(() => {
        dispatch(alertsWizardAlertSearchWarnings())
    }, [])

    const configButtons = [
        {
            id: 'warnings',
            name: messages['alertsNewAlert_Warnings'],
            color: 'green',
        },
        {
            id: 'all',
            name: messages['alertsNewAlert_all'],
            color: 'red',
        }
    ];

    const handleOptions = (type) => {
        if (type === "all") {
            onChange({ ...value, warnings: ["All"], type: type })
        } else {
            onChange({ ...value, warnings: [], type: type })
        }
    }

    return (
        <Form
            ref={formRef}
            onSubmit={() => {
                return value?.warnings?.length > 0;
            }}>
            <Grid container>
                <Grid item xs={12} style={{ marginBottom: 8 }}>
                    <label className='input-normal-label'>{messages['alertsNewAlert_SetWarnings']} <span className="text-danger"> *</span></label>
                </Grid>
                {
                    configButtons.map((item, index) => {
                        return (
                            <Grid item xs={6} key={index} style={{ padding: '0 2px' }}>
                                <Pill
                                    style={{ width: '100%' }}
                                    item={{ name: item?.name, color: value?.type === item?.id ? "#66bb6a" : "#f1f1f1" }}
                                    outlined={false}
                                    onClick={() => handleOptions(item?.id)}
                                />
                            </Grid>
                        )
                    })
                }
            </Grid>
            <Grid item xs={12}>
                {
                    value?.warnings?.length == 0 &&
                    <small className="text-danger"> {messages['alertsNewAlert_WarningsValidation']}</small>
                }
                {
                    value?.type === "warnings" &&
                    <Grid container style={{ marginTop: 20 }}>
                        {
                            warnings.map((item) => {
                                return (
                                    <Grid item key={item.id} sm={6} style={{ padding: '0 2px' }}>
                                        <Pill
                                            textField={'name'}
                                            item={{ ...item, name: messages[`alertsNewAlert_${item?.code}`] || item?.name }}
                                            outlined={value?.warnings?.length ? !value?.warnings.some((code) => code === item?.code) : true}
                                            onClick={() => {
                                                let currentWarnings = value?.warnings || []
                                                let indexWarning = currentWarnings.findIndex((warning) => warning === item?.code)
                                                if (indexWarning > -1) {
                                                    currentWarnings.splice(indexWarning, 1)
                                                } else {
                                                    currentWarnings.push(item?.code)
                                                }
                                                onChange({ ...value, warnings: currentWarnings, type: "warnings" })
                                            }}
                                            style={{ border: '0', margin: '2px 0', width: '100%' }}
                                            label="pill-label-text"
                                            colorField="default"
                                        />
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                }
            </Grid>
        </Form>
    );
}